import API from '../services/API.js'

// Downloads a server-generated file (CSV export, PDF, ...) through the
// authenticated axios instance. Never use window.open for API downloads: a
// plain browser navigation carries no X-Tenant-Subdomain header, so in
// production the API host can't resolve the tenant and the download 404s.
// Returns true on success; on failure returns false and leaves the caller
// to surface res.data?.error (read off the returned response).
const downloadFile = async (url, filename) => {
  const res = await API.get(url, { responseType: 'blob' })
  if (res.status !== 200) {
    // Error bodies arrive as a Blob when responseType is 'blob' - decode it
    // so callers can show the server's message
    let error
    try {
      error = JSON.parse(await res.data.text())?.error
    } catch {
      // Not JSON - fall through to a generic message
    }
    return { ok: false, error: error || 'Download failed' }
  }

  const objectUrl = URL.createObjectURL(res.data)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  link.click()
  URL.revokeObjectURL(objectUrl)
  return { ok: true }
}

export default downloadFile
